import React from "react";
import AutoResizeTextarea from "../AutoResizeTextarea";

const PanelActivite = ({
  indicators,
  isDirty,
  setIsDirty,
  editableResult,
  setEditableResult,
}) => {
  const client = indicators?.client || {};
  const cr = indicators?.compte_de_resultat || {};

  const exerciceN = client.exercice_N || "N";
  const exerciceN1 = client.exercice_N1 || "N-1";

  const caN = cr.ca_N || 0;
  const caN1 = cr.ca_N1 || 0;
  const achatsN = cr.achats_N || 0;
  const achatsN1 = cr.achats_N1 || 0;
  const chargesNonStockeesN = cr.charges_non_stockees_N || 0;
  const chargesNonStockeesN1 = cr.charges_non_stockees_N1 || 0;
  const chargesExternesN = cr.charges_externes_N || 0;
  const chargesExternesN1 = cr.charges_externes_N1 || 0;
  const chargesFiscalesN = cr.charges_fiscales_N || 0;
  const chargesFiscalesN1 = cr.charges_fiscales_N1 || 0;
  const chargesPersonnelN = cr.charges_personnel_N || 0;
  const chargesPersonnelN1 = cr.charges_personnel_N1 || 0;
  const dotationsN = cr.dotations_amortissements_N || 0;
  const dotationsN1 = cr.dotations_amortissements_N1 || 0;
  const chargesGestionN = cr.charges_gestion_N || 0;
  const chargesGestionN1 = cr.charges_gestion_N1 || 0;
  const margeCommercialeN = cr.marge_commerciale_N || 0;
  const margeCommercialeN1 = cr.marge_commerciale_N1 || 0;
  const valeurAjouteeN = cr.valeur_ajoutee_N || 0;
  const valeurAjouteeN1 = cr.valeur_ajoutee_N1 || 0;
  const ebeN = cr.ebe_N || 0;
  const ebeN1 = cr.ebe_N1 || 0;
  const ebeVarPct = cr.ebe_var_pct || 0;
  const produitGestN = cr.produit_gest_N || 0;
  const produitGestN1 = cr.produit_gest_N1 || 0;
  const rexN = cr.rex_N || 0;
  const rexN1 = cr.rex_N1 || 0;
  const chargesFinancieresN = cr.charges_financieres_N || 0;
  const chargesFinancieresN1 = cr.charges_financieres_N1 || 0;
  const impotN = cr.impot_N || 0;
  const impotN1 = cr.impot_N1 || 0;
  const resultatNetN = cr.resultat_net_N || 0;
  const resultatNetN1 = cr.resultat_net_N1 || 0;
  const resultatNetVarPct = cr.resultat_net_var_pct || 0;

  const fmt = (v, d = 0) =>
    Number(v).toLocaleString("fr-FR", {
      minimumFractionDigits: d,
      maximumFractionDigits: d,
    });
  const fmtE = (v) => fmt(v) + " €";
  const fmtPct = (v) => (v >= 0 ? "+" : "") + fmt(v, 1) + "%";
  const deltaClass = (v) => (v >= 0 ? "pos" : "neg");
  const deltaArrow = (v) => (v >= 0 ? "▲" : "▼");
  const pctCA = (val, ca) => {
    if (!ca || ca === 0) return "—";
    return fmt((val / ca) * 100, 1) + "%";
  };

  const ebeKpi = ebeN >= 0 ? "kpi-green" : "kpi-red";
  const rnKpi = resultatNetN >= 0 ? "kpi-green" : "kpi-red";

  const sigRow = (label, n, n1, cls) => {
    const v = n - n1;
    const p = n1 !== 0 ? ((v / Math.abs(n1)) * 100).toFixed(1) : "—";
    const sign = v >= 0 ? "+" : "";
    const vClass = v >= 0 ? "v-pos" : "v-neg";
    const trClass = cls === "group" ? "tr-g" : cls === "total" ? "tr-tot" : "";
    return { label, n, n1, v, p, sign, vClass, trClass };
  };

  const rows = [
    sigRow("Chiffre d'affaires", caN, caN1, "group"),
    sigRow("Achats consommés", -achatsN, -achatsN1, ""),
    sigRow("Marge commerciale", margeCommercialeN, margeCommercialeN1, "group"),
    sigRow(
      "Charges non stockées",
      -chargesNonStockeesN,
      -chargesNonStockeesN1,
      ""
    ),
    sigRow("Charges externes", -chargesExternesN, -chargesExternesN1, ""),
    sigRow("Valeur ajoutée", valeurAjouteeN, valeurAjouteeN1, "group"),
    sigRow("Charges de personnel", -chargesPersonnelN, -chargesPersonnelN1, ""),
    sigRow("Charges fiscales", -chargesFiscalesN, -chargesFiscalesN1, ""),
    sigRow("EBE", ebeN, ebeN1, "group"),
    sigRow("Produits de gestion", produitGestN, produitGestN1, ""),
    sigRow("Dotations amortissements", -dotationsN, -dotationsN1, ""),
    sigRow("Charges de gestion", -chargesGestionN, -chargesGestionN1, ""),
    sigRow("Résultat d'exploitation", rexN, rexN1, "group"),
    sigRow(
      "Charges financières",
      -chargesFinancieresN,
      -chargesFinancieresN1,
      ""
    ),
    sigRow("Impôt", impotN, impotN1, ""),
    sigRow("Résultat net", resultatNetN, resultatNetN1, "total"),
  ];

  return (
    <div className="activite-wrapper">
      <style>{`
        .activite-wrapper {
          --brand:#7E1738; --brand-mid:#9B1F44;
          --bg:#F5F3F7;
          --border:#E6E3EC; --border-light:#F0EDF4;
          --text:#1A1525; --text-2:#4A4460; --muted:#8A849A;
          --blue:#2563EB; --blue-bg:#EFF6FF; --blue-mid:#DBEAFE;
          --green:#16A34A; --green-bg:#F0FDF4; --green-mid:#DCFCE7;
          --red:#DC2626; --red-bg:#FEF2F2; --red-mid:#FEE2E2;
          --purple:#7C3AED; --purple-bg:#F5F3FF; --purple-mid:#EDE9FE;
          --indigo:#4F46E5; --indigo-bg:#EEF2FF; --indigo-mid:#C7D2FE;
          --radius:10px;
          font-family:'DM Sans',system-ui,sans-serif;
          color:var(--text);
          font-size:13px;
          padding:20px 28px 32px;
          background:var(--bg);
          display:flex;
          flex-direction:column;
        }

        .act-grid{
          display:grid;
          grid-template-columns:60% 40%;
          gap:16px;
          align-items:stretch;
        }

        /* Table : prend toute la hauteur sans scroll */
        .act-left{
          display:flex;
          flex-direction:column;
        }
        .act-tbl-wrap{
          border-radius:10px;
          border:1px solid var(--border);
          background:#fff;
          overflow:hidden;
          height:100%;
          display:flex;
          flex-direction:column;
        }
        .act-tbl-wrap table{
          width:100%;
          height:100%;
          border-collapse:collapse;
          font-size:12.5px;
        }
        .act-tbl-wrap thead th{
          background:var(--bg);
          color:var(--text-2);
          padding:10px 12px;
          text-align:left;
          font-size:11px;
          font-weight:600;
          letter-spacing:.04em;
          border-bottom:1px solid var(--border);
          white-space:nowrap;
        }
        .act-tbl-wrap thead th:not(:first-child){text-align:right}
        .act-tbl-wrap td{
          padding:10px 12px;
          color:var(--text-2);
          border-bottom:1px solid var(--border-light);
          vertical-align:middle;
        }
        .act-tbl-wrap td:not(:first-child){
          text-align:right;
          font-variant-numeric:tabular-nums;
        }
        .act-tbl-wrap tbody tr:last-child td{border-bottom:none}
        .act-tbl-wrap tbody tr:hover{background:var(--bg)}
        .act-tbl-wrap .tr-g td{background:#F0EDF4!important;color:var(--text);font-weight:600}
        .act-tbl-wrap .tr-tot td{background:var(--brand)!important;color:rgba(255,255,255,.95)!important;font-weight:600}
        .v-pos{color:var(--green)!important;font-weight:600}
        .v-neg{color:var(--red)!important;font-weight:600}
        .act-tbl-wrap .tr-tot .v-pos,
        .act-tbl-wrap .tr-tot .v-neg{
          color:rgba(255,255,255,.95)!important;
        }

        /* Colonne droite */
        .act-right{
          display:flex;
          flex-direction:column;
          gap:12px;
        }
        .act-kpi-grid{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:10px;
        }
        .act-kpi-card{
          background:var(--kpi-bg,var(--blue-bg));
          border:1px solid var(--kpi-mid,var(--blue-mid));
          border-radius:var(--radius);
          padding:14px 16px;
          display:flex;
          flex-direction:column;
          gap:3px;
          transition:transform .15s,box-shadow .15s;
        }
        .act-kpi-card:hover{
          transform:translateY(-1px);
          box-shadow:0 4px 16px rgba(0,0,0,.07);
        }
        .act-kpi-number{
          font-size:18px;
          font-weight:700;
          color:var(--kpi-color,var(--blue));
          line-height:1.1;
          letter-spacing:-.02em;
        }
        .act-kpi-lbl{
          font-size:11px;
          font-weight:500;
          color:var(--kpi-color,var(--blue));
          opacity:.75;
          margin-top:1px;
        }
        .act-kpi-delta{
          display:inline-flex;
          align-items:center;
          font-size:10px;
          font-weight:500;
          padding:2px 8px;
          border-radius:20px;
          margin-top:5px;
          width:fit-content;
        }
        .act-kpi-delta.neg{background:rgba(220,38,38,.1);color:#B91C1C}
        .act-kpi-delta.pos{background:rgba(22,163,74,.1);color:#15803D}
        .act-kpi-delta.neu{background:rgba(100,100,120,.08);color:var(--text-2)}
        .kpi-blue{--kpi-bg:var(--blue-bg);--kpi-mid:var(--blue-mid);--kpi-color:var(--blue)}
        .kpi-green{--kpi-bg:var(--green-bg);--kpi-mid:var(--green-mid);--kpi-color:var(--green)}
        .kpi-red{--kpi-bg:var(--red-bg);--kpi-mid:var(--red-mid);--kpi-color:var(--red)}
        .kpi-purple{--kpi-bg:var(--purple-bg);--kpi-mid:var(--purple-mid);--kpi-color:var(--purple)}

        .act-tile-analyse{
          background:var(--indigo-bg);
          border:1px solid var(--indigo-mid);
          border-left:3px solid var(--indigo);
          border-radius:var(--radius);
          padding:16px 18px;
        }
        .act-tile-analyse-head{
          display:flex;
          align-items:center;
          gap:8px;
          margin-bottom:10px;
        }
        .act-tile-analyse-lbl{
          font-size:10px;
          font-weight:700;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--indigo);
        }
        .act-tile-analyse p{
          font-size:12.5px;
          line-height:1.8;
          color:#3730A3;
        }
        .act-tile-infos{
          background:#FDF0F3;
          border:1px solid #F2D0DA;
          border-left:3px solid var(--brand);
          border-radius:var(--radius);
          padding:16px 18px;
        }
        .act-tile-infos-head{
          font-size:10px;
          font-weight:700;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--brand);
          margin-bottom:10px;
        }
        .act-tile-infos p{
          font-size:12.5px;
          line-height:1.8;
          color:var(--text-2);
        }
      `}</style>

      <div className="act-grid">
        {/* ── COLONNE GAUCHE : Tableau SIG ── */}
        <div className="act-left">
          <div className="act-tbl-wrap">
            <table>
              <thead>
                <tr>
                  <th>Indicateur</th>
                  <th>{exerciceN}</th>
                  <th>{exerciceN1}</th>
                  <th>Écart</th>
                  <th>%</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i} className={row.trClass}>
                    <td>{row.label}</td>
                    <td>{fmtE(row.n)}</td>
                    <td>{fmtE(row.n1)}</td>
                    <td className={row.vClass}>
                      {row.sign}
                      {fmtE(row.v)}
                    </td>
                    <td className={row.vClass}>
                      {row.sign}
                      {row.p}
                      {row.p !== "—" ? "%" : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── COLONNE DROITE ── */}
        <div className="act-right">
          <div className="act-kpi-grid">
            <div className={`act-kpi-card ${ebeKpi}`}>
              <div className="act-kpi-number">{fmtE(ebeN)}</div>
              <div className="act-kpi-lbl">EBE {exerciceN}</div>
              <span className={`act-kpi-delta ${deltaClass(ebeVarPct)}`}>
                {deltaArrow(ebeVarPct)} {fmtPct(ebeVarPct)}
              </span>
            </div>

            <div className="act-kpi-card kpi-blue">
              <div className="act-kpi-number">
                {pctCA(margeCommercialeN, caN)}
              </div>
              <div className="act-kpi-lbl">Taux marge</div>
              <span className="act-kpi-delta neu">
                vs {pctCA(margeCommercialeN1, caN1)}
              </span>
            </div>

            <div className={`act-kpi-card ${rnKpi}`}>
              <div className="act-kpi-number">{fmtE(resultatNetN)}</div>
              <div className="act-kpi-lbl">Résultat net</div>
              <span
                className={`act-kpi-delta ${deltaClass(resultatNetVarPct)}`}
              >
                {deltaArrow(resultatNetVarPct)} {fmtPct(resultatNetVarPct)}
              </span>
            </div>

            <div className="act-kpi-card kpi-purple">
              <div className="act-kpi-number">
                {pctCA(chargesPersonnelN, caN)}
              </div>
              <div className="act-kpi-lbl">Personnel / CA</div>
              <span className="act-kpi-delta neu">
                vs {pctCA(chargesPersonnelN1, caN1)}
              </span>
            </div>
          </div>

          <div
            className="rounded-md border-l-[3px] p-4"
            style={{ backgroundColor: "#EEF2FF", borderLeftColor: "#4F46E5" }}
          >
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs font-semibold text-indigo-700 uppercase tracking-wide">
                Analyse
              </p>

              {isDirty.analyseActvite && (
                <span className="bg-amber-100 text-amber-700 border border-amber-200 text-[10px] px-2 py-0.5 rounded-md shadow-sm">
                  Modifié
                </span>
              )}
            </div>

            <AutoResizeTextarea
              value={editableResult?.activite?.analyse || ""}
              onChange={(e) => {
                setIsDirty((prev) => ({
                  ...prev,
                  analyseActvite: true,
                }));
                setEditableResult((prev) => ({
                  ...prev,
                  activite: {
                    ...prev.activite,
                    analyse: e.target.value,
                  },
                }));
              }}
              className="text-indigo-900/80"
            />
          </div>

          <div
            className="rounded-md border-l-[3px] p-4"
            style={{ backgroundColor: "#FDF0F3", borderLeftColor: "#7E1738" }}
          >
            <div className="flex items-center justify-between mb-2">
              <p
                className="text-xs font-semibold uppercase tracking-wide"
                style={{ color: "#7E1738" }}
              >
                Informations & Recommandations
              </p>

              {isDirty.informations_recommandationsActivite && (
                <span className="bg-amber-100 text-amber-700 border border-amber-200 text-[10px] px-2 py-0.5 rounded-md shadow-sm">
                  Modifié
                </span>
              )}
            </div>

            <AutoResizeTextarea
              value={
                editableResult?.activite?.informations_recommandations || ""
              }
              onChange={(e) => {
                setIsDirty((prev) => ({
                  ...prev,
                  informations_recommandationsActivite: true,
                }));
                setEditableResult((prev) => ({
                  ...prev,
                  activite: {
                    ...prev.activite,
                    informations_recommandations: e.target.value,
                  },
                }));
              }}
              className="text-foreground/80"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelActivite;
